const packageMetadata = require('../package.json') as { version: string };

export const RELEASE_VERSION = packageMetadata.version;

export const releaseNotesKeyForVersion = (version: string) =>
  `v${version.replace(/[^a-zA-Z0-9_-]/g, '_')}`;

export const CURRENT_RELEASE_NOTES_KEY =
  releaseNotesKeyForVersion(RELEASE_VERSION);
export const CURRENT_RELEASE_NOTES_PATH = `release_notes/${CURRENT_RELEASE_NOTES_KEY}`;
